import ArcIcon from '@assets/images/ai-robot.svg?react'
import { TaskSource } from '@common/interfaces/task'
import { IconOrSvg } from '../../components/Common/Icon'

export const TASK_SOURCE_ICONS: Record<TaskSource, IconOrSvg> = {
  [TaskSource.Funding]: 'banknote',
  [TaskSource.Collections]: 'collections',
  [TaskSource.Reporting]: 'reporting',
  [TaskSource.FlagsInvestigation]: 'flag-flat',
  [TaskSource.BDDocuments]: 'briefcase',
  [TaskSource.DDDocuments]: 'underwriting',
  [TaskSource.CommitteeSubmission]: 'people',
  [TaskSource.Amendments]: 'file-pen',
  [TaskSource.TermsApproval]: 'percent',
  [TaskSource.Manual]: 'user',
  [TaskSource.Arc]: ArcIcon,
  [TaskSource.Call]: 'phone',
  [TaskSource.Message]: 'chat-notification',
  [TaskSource.Feedback]: 'message-text',
}
